export function DiamondSkeleton() {
  return (
    <div className="skeleton-page">
      {/* LEFT: gallery skeleton */}
      <div className="skeleton-gallery">
        <div className="skeleton-thumbs">
          <div className="sk-thumb"></div>
          <div className="sk-thumb"></div>
          <div className="sk-thumb"></div>
          <div className="sk-thumb"></div>
        </div>

        <div className="sk-main"></div>
      </div>

      {/* RIGHT: content skeleton */}
      <div className="skeleton-content">
        <div className="sk-title" style={{marginBottom:30}}></div>
        <div className="sk-link" style={{marginBottom:30}}></div>
        <div className="sk-price-small"></div>
        <div className="sk-price-big" style={{marginBottom:40}}></div>

        {/* tabs */}
        <div className="sk-tabs" >
          <div className="sk-tab"></div>
          <div className="sk-tab"></div>
          <div className="sk-tab"></div>
        </div>

        {/* specs */}
        <div className="sk-spec-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="sk-spec-row">
              <div className="sk-spec-label"></div>
              <div className="sk-spec-value"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}